import { render, staticRenderFns } from "./news.vue?vue&type=template&id=714b55ce&scoped=true"
import script from "./news.vue?vue&type=script&lang=ts"
export * from "./news.vue?vue&type=script&lang=ts"
import style0 from "./news.vue?vue&type=style&index=0&id=714b55ce&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "714b55ce",
  null
  
)

export default component.exports